import { render, staticRenderFns } from "./AccountHome.vue?vue&type=template&id=5bf8d66f&scoped=true&"
import script from "./AccountHome.vue?vue&type=script&lang=js&"
export * from "./AccountHome.vue?vue&type=script&lang=js&"
import style0 from "./AccountHome.vue?vue&type=style&index=0&id=5bf8d66f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8d66f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
